export const SIGN_IN = "SIGN_IN";// signIn
export const ERROR_SIGN_IN = "ERROR_SIGN_IN";// signIn
export const SIGN_OUT = "SIGN_OUT";// signOut
